import {
  arrayJsonFormat,
  dateJsonFormat,
  JsonFormat,
  objectJsonFormat,
  stringEnumJsonFormat,
  stringJsonFormat,
} from "@redotech/json/format";
import { Integration, ProviderType } from "./integration-schema-definition";

export const commonIntegrationJsonFormatFields = {
  _id: stringJsonFormat,
  team: stringJsonFormat,
  createdAt: dateJsonFormat,
  updatedAt: dateJsonFormat,
  provides: arrayJsonFormat(stringEnumJsonFormat(ProviderType)),
};

export const integrationJsonFormat: JsonFormat<Integration> = objectJsonFormat(
  { ...commonIntegrationJsonFormatFields },
  {},
);
